import script from "./SideBarLink.vue?vue&type=script&setup=true&lang=js"
export * from "./SideBarLink.vue?vue&type=script&setup=true&lang=js"

import "./SideBarLink.vue?vue&type=style&index=0&id=1172999f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1172999f"]])

export default __exports__